import { Box } from "@mui/material";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import LandingPageCarousel from "components/LandingPageCarousel";
import LandingPageClaim from "components/LandingPaceClaim";
import LandingPageCards from "./LandingPageCards";
import LandingPageBPMNPreview from "./LandingPageBPMNPreview";
import LandingPageStats from "./LandingPageStats";
import LandingPageCTA from "./LandingPageCTA";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { noTokenApi } from "api";
import { addMessage } from "Redux/messageReducer";
import LandingPageTemplate from "./templates/LandingPageTemplate";

export default function LandingPage() {
    const [lang, setLang] = useState('en');
    const [isScrolled, setIsScrolled] = useState(false);
    const dispatch = useDispatch();

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTop = event.currentTarget.scrollTop;
        const scrolled = scrollTop > 50;
        setIsScrolled(scrolled);
    };

    useEffect(() => {
        (async () => {
            const browserLang = navigator.language.split("-")[0];
            setLang(browserLang);
            const result = await noTokenApi.get(`messages/${browserLang}`);
            document.documentElement.setAttribute("lang", browserLang);
            dispatch(addMessage(result.data.messages));
        })();
    }, [dispatch]);

    return (
        <Box sx={{ height: "100vh", overflowY: "auto" }} onScroll={handleScroll}>
            <LandingPageTemplate
                navbar={<Navbar lang={lang} isScrolled={isScrolled} />}
                carousel={<LandingPageCarousel lang={lang} />}
                claim={<LandingPageClaim lang={lang} />}
                cards={<LandingPageCards lang={lang} />}
                bpmnPreview={<LandingPageBPMNPreview lang={lang} />}
                stats={<LandingPageStats lang={lang} />}
                cta={<LandingPageCTA lang={lang} />}
                footer={<Footer lang={lang} />}
            />
        </Box>
    );
}
